import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRoutesObject } from "../../../pages/app-routes.component";
import { selectTopStripData } from "../../../store/org/org.selector";
import { useDispatch } from "react-redux";
import { setTopUpOrgId } from "../../../store/global-modals/global-modals.reducer";
import {
  useGetOrgsQuery,
  useGetSummariesQuery,
  useUsersSyncQuery,
} from "../../../store/api/api";

export const TopStrip = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectTopStripData);
  const { bgColor, org, code, strong, text } = data;
  const [prefix, suffix] = strong ? text.split(strong) : ["", ""];
  const navigate = useNavigate();
  const onClick = () => {
    if (code === "CRM Trial") {
      window.open(
        "https://superfone.odoo.com/book/sf-setup-trialcrm",
        "_blank"
      );
      return;
    } else if ((code || "").toLowerCase().includes("minutes") && org?.id) {
      dispatch(setTopUpOrgId(org.id));
    }
    navigate(AppRoutesObject.Teams.url);
  };
  const { isSuccess: isOrgsSuccess } = useGetOrgsQuery();
  const { isSuccess: isSummariesSuccess } = useGetSummariesQuery();
  const location = useLocation();
  const { data: usersSync } = useUsersSyncQuery();

  if (!usersSync?.current_subscription?.subscription) {
    return null;
  }
  if (!prefix && !suffix && !strong) {
    return null;
  }
  if (location.pathname === AppRoutesObject.Teams.url) {
    return null;
  }

  return isOrgsSuccess && isSummariesSuccess ? (
    <div
      style={{
        lineHeight: "2rem",
        cursor: "pointer",
        textAlign: "center",
      }}
      onClick={onClick}
    >
      <div
        style={{
          background: bgColor,
          color: "blue",
          textDecoration: "underline",
        }}
      >
        {prefix ? <span>{prefix}</span> : null}
        <strong>{strong}</strong>
        {suffix ? <span>{suffix}</span> : null}
      </div>
    </div>
  ) : null;
};
